import { useAppSelector } from 'app/hooks';
import { useCallback, useRef } from 'react';

export default function useSystemsAwaitingFirstSave() {
  const { existingSystems, equipmentSaveVersion } = useAppSelector(
    (state) => state.structure
  );
  const firstSeenVersionsRef = useRef<Map<string, number> | null>(null);
  if (firstSeenVersionsRef.current === null) {
    firstSeenVersionsRef.current = new Map(
      existingSystems.map((system) => [
        system.uniqueId,
        equipmentSaveVersion - 1
      ])
    );
  }
  const firstSeenVersions = firstSeenVersionsRef.current;
  existingSystems.forEach((system) => {
    if (!firstSeenVersions.has(system.uniqueId)) {
      firstSeenVersions.set(system.uniqueId, equipmentSaveVersion);
    }
  });

  return useCallback(
    (systemUniqueId: string): boolean =>
      equipmentSaveVersion <=
      (firstSeenVersions.get(systemUniqueId) ?? equipmentSaveVersion),
    [equipmentSaveVersion, firstSeenVersions]
  );
}
